import { inject, Injectable } from '@angular/core';
import { Apollo, ApolloBase, gql } from 'apollo-angular';
import { Subject, distinctUntilChanged, filter, map, tap } from 'rxjs';
import { AppIcon } from 'src/app/models/appicon.interface';

@Injectable({
    providedIn: 'root',
})
export class AppIconsService {
    // Common
    public error = new Subject<boolean>();
    public errorMsg = '';
    // Version information
    public vloading = new Subject<boolean>();
    public version = 'Not loaded';
    public vloaded = new CustomEvent('appiconsloaded');
    // Icons
    public loading = new Subject<boolean>();
    public icons = new Array<AppIcon>();
    public loaded = new CustomEvent('appiconsloaded');

    private readonly apolloProvider = inject(Apollo);
    private readonly apollo: ApolloBase = this.apolloProvider.use('icons');

    getAll() {
        this.getVersion();
        this.getAppIcons();
    }

    getVersion() {
        this.vloading.next(true);
        this.apollo
            .watchQuery({
                query: gql`
                    {
                        version
                    }
                `,
            })
            .valueChanges.subscribe((result: any) => {
                const data = result?.data;
                if (data) {
                    this.version = data.version;
                }
                if (result.error) {
                    this.errorMsg = result.errorMsg;
                    this.error.next(result.error);
                } else {
                    this.errorMsg = '';
                    this.error.next(result.error);
                }
                if (!result.loading) {
                    dispatchEvent(this.vloaded);
                }
                this.vloading.next(false);
            });
    }

    getAppIcons() {
        this.loading.next(true);
        this.apollo
            .watchQuery({
                query: gql`
                    {
                        appicons {
                            name
                            files
                        }
                    }
                `,
            })
            .valueChanges.pipe(
                filter((result: any) => !result?.loading),
                map((result: any) => {
                    const data = result?.data;
                    const rawIcons = (data?.appicons ?? []).filter(
                        (appIcon: any) => appIcon?.name !== 'fonts',
                    );
                    const icons = rawIcons.map(
                        (appIcon: any) => new AppIcon(appIcon),
                    );

                    const signature = rawIcons
                        .map(
                            (i: any) =>
                                `${i?.name ?? ''}|${Array.isArray(i?.files) ? i.files.length : ''}`,
                        )
                        .join(',');

                    return { result, icons, signature };
                }),
                distinctUntilChanged(
                    (prev, next) => prev.signature === next.signature,
                ),
                tap(({ result, icons }) => {
                    this.icons = icons;

                    if (result.error) {
                        this.errorMsg = result.errorMsg;
                        this.error.next(result.error);
                    } else {
                        this.errorMsg = '';
                        this.error.next(result.error);
                    }

                    dispatchEvent(this.loaded);
                    this.loading.next(false);
                }),
            )
            .subscribe();
    }

    getImgUrl(icon: AppIcon, index: number): string {
        return icon.files[index];
    }
}
